import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalChangeSpecificPricesProps extends ModalChangeSpecificPricesLogicProps {
}

const ModalChangeSpecificPrices: React.FC<ModalChangeSpecificPricesProps> = ({ setOpenModal, ...rest }) => {
    const { t } = useTwinTranslation()
    const { changeSellTicketPrices, loading } = useModalChangeSpecificPricesLogic({ setOpenModal, ...rest })
    return (
        <ModalSmallFilled opened={true} setOpened={rest.setOpened} onCancel={() => setOpenModal(null)} onAccept={changeSellTicketPrices} translations={{
            title: t('customerHaveOtherSpecificPriceRules', 'Este cliente tiene otras tarifas'),
            subtitle: t('wantToChangePrices', '¿Quieres cambiar el precio de los productos por los de la nueva tarifa?'),
            buttonAccept: t('accept', 'Aceptar'),
        }} loading={loading} />
    )
}

interface ModalChangeSpecificPricesLogicProps extends ModalEditComponentProps {
    setOpenModal: SetEditDeleteModalTy
}

const useModalChangeSpecificPricesLogic = ({ onSubmit, allRowData, setOpenModal }: ModalChangeSpecificPricesLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()

    const changeSellTicketPrices = useCallback(async () => {
        startLoading?.()
        if (allRowData?.id) {
            const result = await twinFetchPostJSON('/api/app/order/tpv/sellTicket/orderProduct/updateSellTicketProductsBySpecificPrice', {OrderId: allRowData?.id})
            if (result) {
                onSubmit(result, {})
                setOpenModal(null)
            }
        }
        endLoading?.()
    }, [setOpenModal, allRowData, startLoading, endLoading, onSubmit])
    return { changeSellTicketPrices, loading }
}


export default ModalChangeSpecificPrices